export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email rempli automatiquement"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cet email a été généré automatiquement lors de la souscription car aucun email n'a été fourni. Il ne correspond pas nécessairement au vrai email du client."])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email filled automatically"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This email was automatically generated during subscription because no email was provided. It may not correspond to the customer's real email address."])}
      }
    }
  })
}
